/**
 * Kolobok «ICQ» set (Aiwan) — same files as
 * https://www.kolobok.us/content_plugins/gallery/gallery.php?smiles.14.1
 * Hotlinked from the author site; personal/non‑commercial use per site terms.
 */
const KOLOBOK_ICQ_BASE = 'https://www.kolobok.us/smiles/icq/';

/** Basenames without `.gif`, matching files under {@link KOLOBOK_ICQ_BASE}. */
export const KOLOBOK_ICQ_STEMS = [
  'air_kiss',
  'bad',
  'biggrin',
  'blum1',
  'blush',
  'bomb',
  'bye2',
  'cool',
  'cray',
  'crazy',
  'dance',
  'diablo',
  'drinks',
  'gamer',
  'girl_angel',
  'give_heart',
  'give_rose',
  'good',
  'hang1',
  'hi',
  'ireful',
  'i_am_so_happy',
  'kiss',
  'kiss3',
  'lol',
  'mad',
  'man_in_love',
  'mocking',
  'music',
  'nea',
  'pardon',
  'rofl',
  'sad',
  'scratch_one-s_head',
  'shok',
  'shout',
  'smile',
  'sorry',
  'unknown',
  'wacko1',
] as const;

export const KOLOBOK_ICQ_STEM_SET: ReadonlySet<string> = new Set(KOLOBOK_ICQ_STEMS);

export function kolobokIcqGifUri(stem: string): string {
  return `${KOLOBOK_ICQ_BASE}${stem}.gif`;
}

/** Inserts into outgoing chat text; rendered as inline GIF when stem is known. */
export function encodeKolobokMarker(stem: string): string {
  return `[[kb:${stem}]]`;
}

